import { Injectable, inject } from '@angular/core';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { UserWorkplaceGridObject } from '@libs/types/src/user/object-type/workplace/user-workplace.object';
import { globalStore } from '../../../../shared/shared.global-service';
import { UserService } from '../../../../../services/user.service';

interface State {
    userWorkplaces: UserWorkplaceGridObject | null;
}

const defaultState: State = {
    userWorkplaces: null,
};

@Injectable()
export class UserWorkplaceTableStore extends ComponentStoreFactory<State> {

    constructor() {
        super(defaultState, globalStore, inject(UserService));
    }

}
